module.exports = __webpack_public_path__ + "static/media/Salmon.0b18e5b4.png";